import { Store } from 'libx'
import User from 'domain/User'
import memoize from 'memoizee'
import { runInAction, action } from 'mobx'

export default class UserStore extends Store {
  constructor () {
    super(...arguments)
    this.refreshProfile = memoize(this.refreshProfile, { promise: true, length: 1 })
    this.users = this.collection({
      model: User,
      idAttribute: 'user_id',
      getModelId: (user) => user.id
    })

    this.rootStore.authStore.onLogout(action(() => {
      this.refreshProfile.clear()
      this.users.clear()
    }))
    window.us = this
  }

  userByAuthId (id) {
    return this.users.get(id)
  }

  changeEmail (newEmail) {
    return this.rootStore.api.profiles.patch('me', {
      email_address: newEmail
    }).then(this.users.set)
  }

  async refreshProfile (id) {
    const result = await this.rootStore.api.profiles.get(id)
    return runInAction(() => this.users.set(result))
  }

  async refreshProfiles (ids) {
    return Promise.all(ids.map(id => this.refreshProfile(id)))
  }
}



// WEBPACK FOOTER //
// ./src/client/store/UserStore.js